import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';
import { Toaster } from 'sonner';
import { HeaderAuth, AuthPublicOutlet } from '@hero/web-components';

export default function AuthLayout() {
  const { i18n } = useTranslation();

  return (
    <>
      <HeaderAuth />

      <main className="container relative w-screen overflow-x-hidden">
        <section className="flex items-center justify-center min-h-[85dvh] ">
          <div className="md:w-[530px] w-[100%] flex flex-col items-center px-8 py-12 bg-white border rounded-lg ">
            <AuthPublicOutlet>
              <Outlet />
            </AuthPublicOutlet>

            <Toaster
              position="bottom-center"
              dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
              toastOptions={{
                classNames: {
                  error: 'subtitle2 text-black',
                  success: 'subtitle2 text-black',
                  warning: 'subtitle2 text-black',
                  info: 'subtitle2 text-black',
                },
              }}
              icons={{
                success: <img src="/images/toastIcons/success.svg" alt="success" />,
                info: <img src="/images/toastIcons/info.svg" alt="info" />,
                warning: <img src="/images/toastIcons/warning.svg" alt="warning" />,
                error: <img src="/images/toastIcons/error.svg" alt="error" />,
              }}
            />
          </div>
        </section>
      </main>
    </>
  );
}
